import NewExpenseTrip from "./NewExpenseTrip";

export default NewExpenseTrip;
